var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, " -->\n", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM8.75 4.25C8.75 4.66421 8.41421 5 8 5C7.58579 5 7.25 4.66421 7.25 4.25C7.25 3.83579 7.58579 3.5 8 3.5C8.41421 3.5 8.75 3.83579 8.75 4.25ZM7.25 5.9375C6.93934 5.9375 6.6875 6.18934 6.6875 6.5C6.6875 6.81066 6.93934 7.0625 7.25 7.0625H7.4375V11.75C7.4375 12.0607 7.68934 12.3125 8 12.3125C8.31066 12.3125 8.5625 12.0607 8.5625 11.75V6.5C8.5625 6.18934 8.31066 5.9375 8 5.9375H7.25Z",
    fill: "#faa93e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2cd2a2a01e9d70502b681272c35d92a8.svg";
export { ForwardRef as ReactComponent };